import { createContext } from "react";

const AcademicYearContext = createContext();

export default AcademicYearContext;
